import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer3Projektowanie() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/03/projektowanie-Large.jpeg"
          alt="Projektowanie ogrodów - twórzenie projektów zieleni - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Projektowanie ogrodów przydomowych Gdańsk, Gdynia, Kartuzy
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Koncepcje zieleni i aranżacja terenu wokół nowych domów
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Dobrze zaprojektowany ogród to harmonijne połączenie estetyki, funkcjonalności i lokalnego mikroklimatu Pomorza. Tworzymy indywidualne projekty ogrodów dla klientów z Gdańska, Gdyni, Wejherowa i Kaszub, uwzględniając ukształtowanie terenu oraz nasłonecznienie. Gotowy projekt płynnie przekładamy na praktyczne <a href="/zakladanie-ogrodu/kompleksowo" className="underline hover:opacity-80">zakładanie ogrodu od A do Z</a>.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Projektowanie ogrodów
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Proces projektowania ogrodu
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Korzyści dla inwestorów i właścicieli nieruchomości
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Nasza oferta
            </a>
            <a
              href="#5"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Dlaczego warto wybrać nas?
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Projektowanie ogrodów</h2>
          <p>
            <strong>Projektowanie ogrodów</strong> to proces tworzenia
            przestrzeni, która łączy estetykę, funkcjonalność i indywidualne
            potrzeby użytkowników. Nasze projekty są dostosowane zarówno do
            małych działek, jak i rozległych terenów, uwzględniając warunki
            lokalne, takie jak rodzaj gleby, ukształtowanie terenu czy klimat.
          </p>
          <p>
            Zainwestowanie w profesjonalnie zaprojektowany ogród podnosi wartość
            nieruchomości. Dla inwestorów oznacza to większą atrakcyjność
            oferty, a w przypadku działek przeznaczonych na sprzedaż – szybsze
            znalezienie nabywcy. Ogród to nie tylko wizytówka posesji, ale także
            przestrzeń do relaksu, spotkań z bliskimi czy pracy w naturalnym
            otoczeniu.
          </p>
          <p>
            Wybierając nas, możesz liczyć na kompleksową usługę – od wstępnej
            koncepcji aż po pełną realizację. Współpracujemy z doświadczonymi
            specjalistami z zakresu ogrodnictwa, co pozwala nam tworzyć
            przestrzenie dopasowane zarówno do Twoich oczekiwań, jak i do
            budżetu.
          </p>

          <h2 id="2">Proces projektowania ogrodu</h2>
          <p>
            Projektowanie ogrodu to przemyślany i wieloetapowy proces, który
            zapewnia harmonijne połączenie estetyki z funkcjonalnością. Dzięki
            sprawnie zorganizowanemu procesowi, cały projekt realizujemy w
            sposób terminowy i zgodny z założeniami, co pozwala uniknąć
            nieprzewidzianych kosztów. Etapy współpracy obejmują:
          </p>
          <div className="flex flex-row items-center justify-between gap-6 bg-gray-100 rounded-xl overflow-hidden mt-6">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/projektowanie-konsultacja.jpeg"
              alt="Konsultacja w trakcie projektowania ogrodu"
              className="w-[400px] h-full object-cover"
            />
            <div className="flex flex-col items-start justify-center p-6">
              <h3>1. Konsultacja</h3>
              <p>
                Podczas pierwszego spotkania omawiamy Twoje potrzeby, pomysły i
                budżet, a także analizujemy wstępne warunki terenowe. To etap, w
                którym zbieramy wszystkie niezbędne informacje, aby móc stworzyć
                projekt idealnie dopasowany do Twoich oczekiwań. Konsultacja
                obejmuje również omówienie stylu ogrodu, preferencji dotyczących
                roślin oraz funkcji, jakie ma pełnić przestrzeń.
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center justify-between gap-6 bg-gray-100 rounded-xl overflow-hidden mt-6">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/projektowanie-analiza-terenu.jpeg"
              alt="Analiza terenu przed projektowaniem ogrodu"
              className="w-[400px] h-full object-cover"
            />{" "}
            <div className="flex flex-col items-start justify-center p-6">
              <h3>2. Analiza terenu</h3>
              <p>
                Przeprowadzamy szczegółową ocenę działki, uwzględniając jej
                wielkość, nasłonecznienie, rodzaj gleby i dostępność mediów.
                Analizujemy również istniejącą roślinność oraz ewentualne
                ograniczenia przestrzenne. Dzięki temu możemy zaproponować
                rozwiązania, które będą nie tylko estetyczne, ale także
                funkcjonalne i trwałe.
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center justify-between gap-6 bg-gray-100 rounded-xl overflow-hidden mt-6">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/projektowanie-tworzenie-projektu.jpeg"
              alt="Tworzenie projektu ogrodu - etap projektowania"
              className="w-[400px] h-full object-cover"
            />{" "}
            <div className="flex flex-col items-start justify-center p-6">
              <h3>3. Tworzenie projektu</h3>
              <p>
                Przygotowujemy wstępny plan uwzględniający układ ścieżek,
                rabaty, elementy małej architektury, systemy nawadniania i dobór
                roślin. Projekt jest tworzony z myślą o estetyce i
                funkcjonalności, aby spełniał wszystkie Twoje oczekiwania. Każdy
                detal jest konsultowany, aby zapewnić pełną satysfakcję z
                końcowego efektu.
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center justify-between gap-6 bg-gray-100 rounded-xl overflow-hidden mt-6">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/projektowanie-finalizacja-projektu.jpeg"
              alt="Finalizacja projektu ogrodu - przygotowanie dokumentacji"
              className="w-[400px] h-full object-cover"
            />{" "}
            <div className="flex flex-col items-start justify-center p-6">
              <h3>4. Finalizacja projektu</h3>
              <p>
                Po zatwierdzeniu projektu tworzymy szczegółową dokumentację
                techniczną oraz kosztorys, co pozwala precyzyjnie zaplanować
                realizację. Dokumentacja zawiera wszystkie niezbędne informacje
                dotyczące materiałów, roślin i harmonogramu prac. Dzięki temu
                możemy zapewnić, że każdy etap realizacji przebiegnie sprawnie i
                zgodnie z planem.
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center justify-between gap-6 bg-gray-100 rounded-xl overflow-hidden mt-6">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/projektowanie-realizacja.jpeg"
              alt="Realizacja projektu ogrodu - etap wykonawczy"
              className="w-[400px] h-full object-cover"
            />{" "}
            <div className="flex flex-col items-start justify-center p-6">
              <h3>5. Realizacja</h3>
              <p>
                Nasza ekipa zajmie się kompleksowym zakładaniem ogrodu, w tym
                pracami ziemnymi, sadzeniem roślin, instalacją systemów
                nawadniania i budową elementów dekoracyjnych. Dbamy o każdy
                szczegół, aby Twój ogród był nie tylko piękny, ale także
                funkcjonalny i łatwy w utrzymaniu. Dzięki naszemu doświadczeniu
                i pasji do ogrodnictwa, możemy zagwarantować, że efekt końcowy
                spełni wszystkie Twoje oczekiwania.
              </p>
            </div>
          </div>
          <h2 id="3">Korzyści dla inwestorów i właścicieli nieruchomości</h2>
          <p>
            Profesjonalnie zaprojektowany ogród niesie ze sobą szereg korzyści,
            które docenią zarówno inwestorzy, jak i właściciele nieruchomości.
            Dla inwestorów ogród jest elementem podnoszącym wartość rynkową
            działki. Estetyczna przestrzeń zielona staje się ważnym atutem przy
            sprzedaży nieruchomości, zwłaszcza w przypadku domów jednorodzinnych
            czy obiektów komercyjnych.
          </p>
          <p>
            Dla właścicieli posesji ogród to inwestycja w jakość życia. Zielona
            przestrzeń poprawia komfort użytkowania działki, sprzyja
            odpoczynkowi i integracji z naturą, a także wpływa na zdrowie i
            samopoczucie. Odpowiednio zaprojektowany ogród jest także bardziej
            ekonomiczny w utrzymaniu – przemyślany dobór roślin i systemów
            nawadniania pozwala ograniczyć koszty pielęgnacji.
          </p>
          <p>
            Ogród zaprojektowany przez profesjonalistów uwzględnia również
            aspekty ekologiczne, takie jak wykorzystanie wody deszczowej, dobór
            roślin wspierających bioróżnorodność czy minimalizacja ingerencji w
            naturalne ukształtowanie terenu.
          </p>

          <h2 id="4">Nasza oferta</h2>
          <p>
            W naszej ofercie znajdziesz szeroki wachlarz usług projektowych, w
            tym:
          </p>
          <ul>
            <li>tworzenie ogrodów przydomowych i reprezentacyjnych</li>
            <li>aranżacje przestrzeni zielonych wokół budynków komercyjnych</li>
            <li>zakładanie trawników – siewem lub z rolki</li>
            <li>projektowanie oczek wodnych i systemów nawadniania</li>
            <li>
              projektowanie ścieżek, podjazdów i elementów małej architektury
            </li>
            <li>dobór i sadzenie roślin zgodnych z wymaganiami klienta</li>
          </ul>
          <p>
            Możemy także doradzić w zakresie pielęgnacji ogrodu oraz
            zaproponować rozwiązania, które pozwolą utrzymać go w idealnym
            stanie przez cały rok.
          </p>

          <h2 id="5">Dlaczego warto wybrać nas?</h2>
          <p>
            Nasze doświadczenie w projektowaniu ogrodów i pasja do tworzenia
            zielonych przestrzeni sprawiają, że każdy projekt traktujemy z
            pełnym zaangażowaniem. Dysponujemy nowoczesnym sprzętem oraz wiedzą,
            która pozwala nam tworzyć ogrody trwałe, estetyczne i funkcjonalne.
          </p>
          <p>
            Oferujemy kompleksowe podejście – od wstępnej analizy, przez
            realizację, aż po doradztwo w zakresie pielęgnacji. Jesteśmy otwarci
            na Twoje pomysły i potrzeby, dostosowując projekt do indywidualnych
            oczekiwań.
          </p>
          <p>
            Skontaktuj się z nami, by omówić swoje potrzeby i stworzyć ogród,
            który stanie się nie tylko piękną ozdobą Twojej posesji, ale także
            przestrzenią, w której będziesz czuł się doskonale każdego dnia.
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col lg:flex-row items-start justify-start lg:items-center lg:justify-between gap-6 lg:gap-24">
          <div className="flex flex-col items-start justify-start gap-2 w-full">
            {" "}
            <h2 className="uppercase color-yellow text-xl">Nasze realizacje</h2>
            <h3 className="text-3xl lg:text-5xl color-green text-left">
              Spójrz jak pomogliśmy<br></br>
              <span className="color-yellow">naszym Klientom</span>
            </h3>
          </div>
          <div className="flex flex-col items-start justify-center w-full lg:w-2/3">
            <p className="text-gray-600 text-left">
              Zobacz stworzone przez nas projekty ogrodów i aranżacje zieleni. Łączymy wiedzę przyrodniczą z nowoczesnym podejściem do projektowania unikalnych przestrzeni przydomowych.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/realizacja-1.jpg"
              alt="Realizacja projektu ogrodu Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-3">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/Realizacja-2.jpg"
              alt="Realizacja projektu ogrodu Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-4.png"
              alt="Realizacja projektu ogrodu Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/projektowanie-1.jpg"
              alt="Projekt ogrodu Drzewus - widok gotowego ogrodu"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/Realizacja-1.jpg"
              alt="Realizacja projektu ogrodu Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
      {/* <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-1.png"
              alt="Portfolio ogrodu Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-2.png"
              alt="Portfolio ogrodu Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-3.png"
              alt="Portfolio ogrodu Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-4.png"
              alt="Portfolio ogrodu Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-5.png"
              alt="Portfolio ogrodu Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-6.png"
              alt="Portfolio ogrodu Drzewus nr 6"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section> */}
    </>
  );
}

export default Offer3Projektowanie;
